export const REDUCER_KEY = 'productExtraFees';
